import { render, staticRenderFns } from "./SetResult.vue?vue&type=template&id=1e8d1b0e&"
import script from "./SetResult.vue?vue&type=script&lang=js&"
export * from "./SetResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports